import React, { useState } from 'react';
import { changeLocale } from "gatsby-plugin-intl";
import { splitListInN } from '../../../utils/splitArrayInN';
import { getCurrentCountryCode } from '../../../utils/getCurrentCountryCode';

export const HeaderLanguageSwitcher = ({ langKey, languages_info }) => {
  const [isLanguageMenuToggled, switchLanguageMenuToggled] = useState(false)
  const country_code = getCurrentCountryCode();

  const switchLanguague = (lang) => {
    // to do
    // remove lang & country_code if exists from window.location.pathname
    let pathname = window.location.pathname.replace(`${langKey}/`, "");
    pathname = pathname.replace(`/${country_code}`, "");
    pathname = pathname.replace('/support-center', '');

    pathname = `/${country_code}${pathname}`;
    console.log(`change language to: ${lang} new path: ${pathname}`);
    changeLocale(lang, pathname);
  }

  // need to split into 3 columns, sort from lowest items in column to highest and remove the selected language from split array
  const languages_info_split = splitListInN(languages_info.filter((lang) => lang.code !== langKey), 3);

  return (
    <div className="navbar-right navbar-language-menu" onBlur={() => { switchLanguageMenuToggled(!isLanguageMenuToggled) }}>
      <div className={`btn-group language-selector-mobile-row dropdown-toggle ${isLanguageMenuToggled ? 'open' : null}`}>
        <a className="btn dropdown-toggle btn-md btn-default" data-toggle="dropdown" href="#" aria-expanded="false"
          onClick={() => { switchLanguageMenuToggled(!isLanguageMenuToggled) }}>
          {languages_info.find((lang) => lang.code === langKey).name}
          <span className="caret"></span>
        </a><ul className="dropdown-menu language-menu multi-column">
          <div className="row">
            {
              languages_info_split.map((language_column, index) => {
                return (
                  <div key={index} className="col-xs-4">
                    <ul>
                      {
                        language_column.map((lang, index) => (
                          <li key={index}>
                            <a onMouseDown={(e) => { switchLanguague(`${lang.code}`) }}>{lang.name}</a>
                          </li>
                        ))
                      }
                    </ul>
                  </div>
                )
              })
            }
          </div>
        </ul>
      </div>
    </div>
  )
}
